export enum ActionTypes {
    HB_CONFIG_LOADED = 'HB_CONFIG_LOADED',
    HB_UI_INTEGRATE_UPDATED = 'HB_UI_INTEGRATE_UPDATED',
    HB_UI_BYOD_UPDATED = 'HB_UI_BYOD_UPDATED',
    HB_KEY_UPDATED = 'HB_KEY_UPDATED',
}



// WEBPACK FOOTER //
// ./src/sub-projects/sensibill/types/action-types.ts